import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { CONTACT } from "@/data/content";
import { useCart } from "@/context/CartContext";

export const Footer = () => {
  const { addToCart } = useCart();
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-black/30 noise">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <img
              src="/assets/veda_logo_dark.png"
              alt="Veda Vitals — Own Your Vitality"
              className="h-16 w-auto"
            />
            <p className="mt-5 text-vmuted max-w-sm leading-relaxed">
              Premium nutrition with expert guidance. ACV Effervescent Tablets, crafted and made in
              India.
            </p>
            <button
              data-testid="footer-buy-btn"
              onClick={() => addToCart("triple")}
              className="mt-7 inline-flex items-center rounded-full bg-gold px-7 py-3 text-obsidian font-medium hover:bg-gold-light transition-colors duration-300"
            >
              Shop Now
            </button>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Contact</p>
            <ul className="space-y-4 text-vmuted">
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-gold" strokeWidth={1.5} />
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-email"
                  className="hover:text-white transition-colors break-all"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-gold" strokeWidth={1.5} />
                <a
                  href={`tel:${CONTACT.phone}`}
                  data-testid="footer-phone"
                  className="hover:text-white transition-colors"
                >
                  {CONTACT.phone}
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Address</p>
            <p className="flex gap-3 text-vmuted text-sm leading-relaxed" data-testid="footer-address">
              <MapPin className="h-4 w-4 text-gold shrink-0 mt-1" strokeWidth={1.5} />
              <span>{CONTACT.address}</span>
            </p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <p className="text-xs text-vmuted">
            © {new Date().getFullYear()} Veda Vitals. All rights reserved.
          </p>
          <p className="text-xs text-white/30 max-w-xl">
            Disclaimer: This product is a food/nutrition supplement. It makes no medical or
            weight-loss claims and is not intended to diagnose, treat, cure or prevent any disease.
          </p>
        </div>
      </div>
    </footer>
  );
};
